import { configStore, contractsStore, loginStore } from "../state/CommonState"
import { useSnapshot } from "valtio"
import HomeScreenLCL from "./home-screen-lcl"
import HomeScreenFCL from "./home-screen-fcl"
import HomeScreenAir from "./home-screen-air"

export default function HomeScreen(props) {
    useSnapshot(contractsStore)
    const rec = contractsStore.current
    //if (!rec || !rec.shipmentType) return <></>
    const stype = configStore.homescreenCurrentShipmentType
    console.log(props,"****",stype);
    switch(stype) {
        case 'LCL': return <HomeScreenLCL shipmentType={stype} {...props}/>
        case 'FCL': return <HomeScreenLCL shipmentType={stype} {...props}/>
        case 'Air': return <HomeScreenLCL shipmentType={stype} {...props}/>
    }
}